var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustratorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.335,
    height: 52,
    viewBox: "0 0 53.335 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "adobe-illustrator-cc-seeklogo.com",
    transform: "translate(362.4 -472.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19131",
    "data-name": "Path 19131",
    d: "M-341.6,493h48.859v47.535H-341.6Z",
    transform: "translate(-18.567 -18.568)",
    fill: "rgba(0,0,0,0.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19132",
    "data-name": "Path 19132",
    d: "M-360.179,474.421H-311.3v47.557h-48.882ZM-362.4,524.2h53.335v-52H-362.4Zm34.934-33.46c0-.182.064-.267.267-.267h3.492c.182,0,.267.064.267.267v17.536c0,.182-.043.267-.267.267h-3.45c-.224,0-.288-.107-.288-.288V490.74Zm-.246-5.052a2.158,2.158,0,0,1,2.264-2.264,2.141,2.141,0,0,1,2.264,2.264,2.12,2.12,0,0,1-2.307,2.264A2.081,2.081,0,0,1-327.712,485.689Zm-10,12.357c-.619-2.467-2.093-7.839-2.649-10.445h-.043c-.47,2.6-1.645,7-2.574,10.445Zm-6.173,3.6-1.752,6.664c-.043.182-.107.224-.331.224h-3.268c-.224,0-.267-.064-.224-.331l6.312-22.086a7.282,7.282,0,0,0,.224-1.848c0-.16.064-.224.182-.224h4.667c.16,0,.224.043.267.224l7.07,23.976c.043.182,0,.288-.182.288H-334.6c-.182,0-.288-.043-.331-.2l-1.826-6.686Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratorLogo);
export default __webpack_public_path__ + "static/media/illustrator-logo.0c10785d22d61f03bc2c57b4ff8ed150.svg";
export { ForwardRef as ReactComponent };